import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MailIcon } from 'lucide-react';
import { PageHero } from '../components/layout/PageHero';
import { SectionHeading } from '../components/ui/SectionHeading';
import { DownloadCard } from '../components/ui/DownloadCard';
import { CtaBand } from '../components/ui/CtaBand';
import { mediaAssets, pressContacts } from '../data/media';
import { articles } from '../data/articles';
export function Media() {
  const pressReleases = articles.filter(article => ['Press Releases', 'Statements', 'Speeches'].includes(article.category)).slice(0, 4);
  return <>
      <PageHero eyebrow="Media centre" title="Everything a newsroom needs, in one place." intro="Official portraits, the candidate biography, campaign brand assets, statements and accreditation — all cleared for editorial use." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Media'
    }]} data-id="element-1075" data-mp="26bda7r3bkld3" />

      <section className="bg-sand-50 py-16 lg:py-24" aria-labelledby="assets-heading" data-id="element-1076" data-mp="3csqjtxr2krqx">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-1077" data-mp="1onkj79jhx3tp">
          <SectionHeading eyebrow="Downloads" title="Official assets" intro="High-resolution files with usage guidance attached to each asset." data-id="element-1078" data-mp="1tlvnl4r0um4j" />
          <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-1079" data-mp="23k1r1qsh80bi">
            {mediaAssets.map(asset => <li key={asset.title} data-id="element-1080" data-mp="15yvzus0nv6k1">
                <DownloadCard item={asset} data-id="element-1081" data-mp="1awfcjnhpnb9v" />
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-white py-16 lg:py-24" aria-labelledby="releases-heading" data-id="element-1082" data-mp="1fuz0ftfv6x4v">
        <div className="mx-auto grid max-w-content gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-10" data-id="element-1083" data-mp="1klyw6vd8z95s">
          <div className="lg:col-span-7" data-id="element-1084" data-mp="n7362vdrphb9">
            <SectionHeading eyebrow="On the record" title="Latest releases and statements" data-id="element-1085" data-mp="n61vst4ksyul" />
            <ul className="mt-8 divide-y divide-sand-300 border-y border-sand-300" data-id="element-1086" data-mp="s4wdtsupyjdn">
              {pressReleases.map(item => <li key={item.slug} data-id="element-1087" data-mp="k35fv7202qwc">
                  <Link to={`/news/${item.slug}`} className="group flex items-start justify-between gap-6 py-5" data-id="element-1088" data-mp="f6oswg6jeiku">
                    <span data-id="element-1089" data-mp="tww01zr3gf68">
                      <span className="text-[11px] font-bold uppercase tracking-[0.1em] text-green-700" data-id="element-1090" data-mp="ovf32fbqdcux">
                        {item.category} · {item.date}
                      </span>
                      <span className="mt-1.5 block font-display text-[19px] leading-snug text-ink" data-id="element-1091" data-mp="3scx86f04c5rn">
                        {item.title}
                      </span>
                    </span>
                    <ArrowRightIcon aria-hidden className="mt-6 h-4 w-4 shrink-0 text-green-600 transition-transform duration-200 ease-emphasis group-hover:translate-x-1" data-id="element-1092" data-mp="65gvs1frbnsc" />
                  </Link>
                </li>)}
            </ul>
            <Link to="/news" className="mt-6 inline-flex items-center gap-2 text-[15px] font-semibold text-green-700" data-id="element-1093" data-mp="1p3lty9gmj4bo">
              View the full newsroom
              <ArrowRightIcon aria-hidden className="h-4 w-4" data-id="element-1094" data-mp="1g3qg1wvoov7y" />
            </Link>
          </div>

          <aside className="lg:col-span-5" data-id="element-1095" data-mp="1k4si0lgzjldm">
            <div className="rounded-media border border-sand-200 bg-sand-100 p-7" data-id="element-1096" data-mp="1k5ka3mbdj0z5">
              <h2 className="font-display text-[22px] text-ink" data-id="element-1097" data-mp="27vo5x7iblwfl">Media contacts</h2>
              <dl className="mt-5 space-y-5" data-id="element-1098" data-mp="2ctzbv75hvmsj">
                {pressContacts.map(contact => <div key={contact.role} data-id="element-1099" data-mp="1z34cclgvyi1m">
                    <dt className="text-[12px] font-bold uppercase tracking-[0.1em] text-slate-500" data-id="element-1100" data-mp="1z22qrn28ud5n">
                      {contact.role}
                    </dt>
                    <dd className="mt-1 text-[15px] text-ink" data-id="element-1101" data-mp="2qsftht4waxpg">{contact.name}</dd>
                    <dd className="mt-0.5" data-id="element-1102" data-mp="2vkqvd1j74tkn">
                      <a href={`mailto:${contact.contact}`} className="inline-flex items-center gap-2 text-[14px] font-medium text-green-700 hover:text-green-800" data-id="element-1103" data-mp="2vlie3brp2wti">
                        <MailIcon aria-hidden className="h-4 w-4" data-id="element-1104" data-mp="xxq152q9h6ne" />
                        {contact.contact}
                      </a>
                    </dd>
                  </div>)}
              </dl>
              <Link to="/contact" className="mt-7 inline-flex h-11 w-full items-center justify-center rounded-lg bg-green-600 text-[15px] font-semibold text-white transition-colors duration-150 ease-emphasis hover:bg-green-700" data-id="element-1105" data-mp="1qmwvrqmlhc3d">
                Request accreditation
              </Link>
            </div>
          </aside>
        </div>
      </section>

      <CtaBand title="Covering the campaign?" description="The weekly campaign schedule and advance notice of major announcements are available to accredited media." primary={{
      label: 'Contact the press office',
      to: '/contact'
    }} secondary={{
      label: 'Facts & answers',
      to: '/facts'
    }} data-id="element-1106" data-mp="29denpszls3no" />
    </>;
}